import { Component, Input, Output, EventEmitter } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  imports: [RouterLink, RouterLinkActive],
  standalone: true,
  templateUrl: './sidebar.html',
  styleUrls: ['./sidebar.css']
})
export class Sidebar {
  @Input() isMobileOpen: boolean = false;
  @Output() closeSidebar = new EventEmitter<void>();

  onNavItemClick() {
    this.closeSidebar.emit();
  }
}